import React from 'react';
import './PrioFilterBtn.css';

export const PrioTitle = {
  1: 'High',
  2: 'Med',
  3: 'Low',
  4: 'None'
};

const PrioFilterBtn = ({prio, clickMe, isActive}) => {

  const handleClickMe = () => {
    clickMe(prio);
  }
  
  const title = PrioTitle[prio] ? PrioTitle[prio] : '?';
  const style = `prioFilterBtn ${title} ${isActive ? 'prioActive' : ''}`;

  return (
    <div className={style} onClick={handleClickMe}>
      {title}
    </div>
  );
};

export default PrioFilterBtn;